import { createMuiTheme } from '@material-ui/core/styles'
import COLORS from './colors'

const theme = createMuiTheme({
	typography: {
		fontFamily: ['Poppins'].join(','),
	},
	palette: {
		primary: {
			main: '#3388FF',
		},
	},
	overrides: {
		MuiTypography: {
			root: {
				color: COLORS.mainTextColor,
			},
			h1: {
				fontSize: 60,
				lineHeight: '82px',
			},
			h2: {
				fontSize: 44,
				lineHeight: '60px',
			},
			h3: {
				fontSize: 40,
				lineHeight: '54px',
			},
			h4: {
				fontSize: 34,
				lineHeight: '48px',
			},
			h5: {
				fontSize: 24,
				lineHeight: '33px',
			},
			subtitle1: {
				fontSize: 20,
				lineHeight: '27px',
			},
			body1: {
				fontSize: 18,
				lineHeight: '30px',
			},
			body2: {
				fontSize: 14,
				lineHeight: '26px',
			},
			caption: {
				fontSize: 12,
				lineHeight: '14px',
			},
		},
	},
})

export default theme
